export enum OG1Classification{
    Unspecified = 0,
    Seller = 1,
    Servicer = 2,
    SellerServicer = 3,
    Inactive = 4
}